import { Children, type ReactNode } from 'react';
import { Link } from 'react-router';
import styles from './ActionTiles.module.css';

/** The main actions of a screen as big icon tiles in one row (call, navigate, done…). */
export function ActionTiles({ children }: { children: ReactNode }) {
  // Every tile can be conditional; an empty row would only leave a gap.
  if (Children.toArray(children).length === 0) return null;
  return <div className={styles.tiles}>{children}</div>;
}

interface ActionTileProps {
  icon: ReactNode;
  label: string;
  /** The yellow, most important action. */
  primary?: boolean;
  to?: string;
  href?: string;
  target?: string;
  rel?: string;
  onClick?: () => void;
}

export function ActionTile({ icon, label, primary, to, href, target, rel, onClick }: ActionTileProps) {
  const className = primary ? `${styles.tile} ${styles.primary}` : styles.tile;
  const content = (
    <>
      {icon}
      <span>{label}</span>
    </>
  );
  if (to) {
    return (
      <Link to={to} className={className}>
        {content}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} target={target} rel={rel} className={className}>
        {content}
      </a>
    );
  }
  return (
    <button type="button" className={className} onClick={onClick}>
      {content}
    </button>
  );
}
